import styled from "styled-components";

export const MainContainer = styled.section`
    width: 100%;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 1rem;
    box-sizing: border-box;

    @media (min-width: 768px) {
        height:100dvh;
        flex-direction: row;
        justify-content: space-between;
        padding: 0;
    }
`;

export const HeaderContainer = styled.div`
width: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;

    img {
        width: 2rem;
        height: 2rem;
        flex-shrink: 0;
    }

    p {
        color: #000;
        font-family: "Clash Grotesk Variable";
        font-size: 1rem;
        font-weight: 500;
    }

    @media (min-width: 768px) {
        position: absolute;
        top: 1rem;
        left: 1rem;
        /* margin-bottom: 0; */
    }
`;

export const BodyContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    /* gap: 2rem; */

    @media (min-width: 768px) {
        flex-direction: row;
        justify-content: space-between;
        padding: 0 2rem;
        gap: 0;
    }
`;

export const LeftContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1.5rem;
    padding: 0 1rem;

    h1 {
        color: #000;
        font-family: "Clash Grotesk Variable";
        font-size: 1.5rem;
        font-weight: 500;
    }

    p {
        color: #000;
        font-family: "Clash Grotesk Variable";
        font-size: 1rem;
        font-weight: 400;
    }

    @media (min-width: 768px) {
        width: 50%;
        align-items: flex-start;
        text-align: left;
        padding-left: 2rem;

        h1 {
            font-size: 2rem;
        }

        p {
            font-size: 1.2rem;
        }
    }
`;

export const CTAContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;

    img {
        width: 6rem;
        height: auto;
    }

    @media (min-width: 768px) {
        justify-content: flex-start;
    }
`;

export const RightContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 90%;
        max-width: 25rem;
        height: auto;
    }

    @media (min-width: 768px) {
        width: 50%;
        padding-right: 2rem;

        img {
            width: 100%;
            max-width: none;
        }
    }
`;
export const CTABtn = styled.button`
background-color: transparent;
border: none;
img{
    width: 7.5rem;
height: 5rem;
}`


export const ComingSoon = styled.p`
    color: #000;
text-align: center;
font-family: "Clash Grotesk Variable";
font-size: 2rem;
font-style: normal;
font-weight: 500 !important;
line-height: normal;
`